import React from 'react';
import StackOneLogoDesaturated from '../assets/logo-stackone-desaturated.png';
import Spacer from './Spacer';
import LinkText from './Typography/LinkText';

interface FooterLinksProps {
    fullWidth?: boolean;
    showDocsSupport?: boolean;
}

const FooterLinks: React.FC<FooterLinksProps> = ({
    fullWidth = false,
    showDocsSupport = false,
}) => {
    const renderLinks = () => {
        if (showDocsSupport) {
            return (
                <Spacer direction="horizontal" size={10}>
                    <LinkText
                        href="https://docs.stackone.com"
                        target="_blank"
                        rel="noopener noreferrer"
                        color="dimmed"
                        fontSize="sm"
                        padding={true}
                        showLeftBorder={!fullWidth}
                        showRightBorder={true}
                    >
                        Docs
                    </LinkText>
                    <LinkText
                        href="https://www.stackone.com/"
                        rel="noopener noreferrer"
                        target="_blank"
                        color="dimmed"
                        fontSize="sm"
                    >
                        Support
                    </LinkText>
                </Spacer>
            );
        }

        return (
            <Spacer direction="horizontal" size={10}>
                <LinkText
                    href="https://www.stackone.com/terms/end-customer-terms"
                    target="_blank"
                    rel="noopener noreferrer"
                    color="dimmed"
                    fontSize="sm"
                    padding={true}
                    showLeftBorder={!fullWidth}
                    showRightBorder={true}
                >
                    Terms
                </LinkText>
                <LinkText
                    href="https://www.stackone.com/terms/privacy-policy"
                    target="_blank"
                    rel="noopener noreferrer"
                    color="dimmed"
                    fontSize="sm"
                >
                    Privacy
                </LinkText>
            </Spacer>
        );
    };

    return (
        <Spacer
            direction="horizontal"
            size={10}
            fullWidth={fullWidth}
            justifyContent={fullWidth ? 'space-between' : undefined}
            align="center"
        >
            <LinkText href="https://www.stackone.com" target="_blank" rel="noopener noreferrer">
                <img
                    src={StackOneLogoDesaturated}
                    width={16}
                    alt="StackOne Logo"
                    style={{
                        opacity: 1,
                        marginLeft: '5px',
                    }}
                />
            </LinkText>
            {renderLinks()}
        </Spacer>
    );
};

export default FooterLinks;
